import React from 'react';

import { Props } from './types';

const EventField: React.FC<Props> = ({ label, children }) => (
  <>
    <div data-event-field className="flex justify-between gap-1 font-medium text-gray-600">
      <span>{label}</span>
      <span>:</span>
    </div>
    <div data-event-field className="min-w-0 break-words text-gray-900">
      {children}
    </div>
  </>
);

export default EventField;
